<template>
  <div class="not-found-container">
    <!-- 404 数字动画 -->
    <div class="number-container">
      <span class="num">4</span>
      <div class="ghost">
        <div class="eye left-eye"></div>
        <div class="eye right-eye"></div>
        <div class="mouth"></div>
      </div>
      <span class="num">4</span>
    </div>

    <!-- 提示文本 -->
    <h2 class="title">页面迷路啦~</h2>
    <p class="desc">你访问的页面不存在、已被移除或路径错误</p>

    <!-- 倒计时提示 -->
    <div class="countdown">
      将在 <span class="count-num">{{ countdown }}</span> 秒后自动返回首页
    </div>

    <!-- 仅保留返回首页按钮 -->
    <router-link to="/page/home" class="btn back-btn">立即返回首页</router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      countdown: 3,
      timer: null
    };
  },
  mounted() {
    // 倒计时跳转逻辑
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.$router.push("/page/home");
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器，避免内存泄漏
  }
};
</script>

<style scoped>
/* 全局容器：居中布局 + 柔和背景 */
.not-found-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

/* 404 数字 + 幽灵图标 */
.number-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.num {
  font-size: 8rem;
  font-weight: 700;
  color: #4a6cf7;
  text-shadow: 0 5px 15px rgba(74, 108, 247, 0.3);
  transition: all 0.3s ease;
}

.number-container:hover .num {
  transform: scale(1.1);
  text-shadow: 0 8px 20px rgba(74, 108, 247, 0.5);
}

/* 幽灵图标 */
.ghost {
  width: 120px;
  height: 140px;
  background: #fff;
  border-radius: 70px 70px 0 0;
  margin: 0 20px;
  position: relative;
  animation: float 3s ease-in-out infinite;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.eye {
  width: 20px;
  height: 20px;
  background: #333;
  border-radius: 50%;
  position: absolute;
  top: 40px;
}

.left-eye {
  left: 35px;
}

.right-eye {
  right: 35px;
}

.mouth {
  width: 40px;
  height: 20px;
  border-radius: 0 0 20px 20px;
  background: #333;
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
}

/* 幽灵浮动动画 */
@keyframes float {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
  100% {
    transform: translateY(0);
  }
}

/* 文本样式 */
.title {
  font-size: 2rem;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}

.desc {
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 30px;
  text-align: center;
  max-width: 500px;
  line-height: 1.6;
}

/* 倒计时样式 */
.countdown {
  font-size: 1rem;
  color: #4a6cf7;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
}

.count-num {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 8px;
  color: #ff6b6b;
}

/* 返回首页按钮 */
.btn.back-btn {
  padding: 12px 40px;
  border-radius: 30px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  text-decoration: none;
  background: #4a6cf7;
  color: #fff;
  box-shadow: 0 5px 15px rgba(74, 108, 247, 0.3);
}

.btn.back-btn:hover {
  background: #3a5edc;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(74, 108, 247, 0.5);
}

</style>